import { defaultTo } from 'ramda';
import { IAppState } from '../../../AppModulesWrapper';
import { EPaymentType, IPaymentData } from '../../types/reducers/paymentProcessing';

export const selectPaymentDataByType =
  (type: EPaymentType) =>
  (state: IAppState): IPaymentData | null => {
    const paymentData = state.servicePickerWidget.paymentProcessing[type];

    return defaultTo(null, paymentData);
  };
